export default "__VITE_ASSET__mY5JmaYL__"